// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__N2Ban","upload":"Small_upload__1Um4c","imageWrap":"Small_imageWrap__380mD","removeBtn":"Small_removeBtn__2W9QB"};